(function() {
    'use strict';

    angular.module("imApp").factory("poShipmentPlanningContainersService", [function() {
        var service = {

        }

        return service;
    }]);
})();
